export function toQueryString(
    params: Record<string, any>,
    options?: { prefix?: string; encode?: boolean }
): string {
    const { prefix = '', encode: shouldEncode = true } = options || {};
    const queryParts: string[] = [];

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const value = params[key];

            if (value === undefined || value === null) continue;

            const encodedKey = shouldEncode ? encodeURIComponent(key) : key;

            if (Array.isArray(value)) {
                value.forEach((item) => {
                    if (item !== undefined && item !== null) {
                        const encodedValue = shouldEncode ? encodeURIComponent(String(item)) : String(item);
                        queryParts.push(`${encodedKey}=${encodedValue}`);
                    }
                });
            } else if (typeof value === 'object') {
                const encodedValue = shouldEncode
                    ? encodeURIComponent(JSON.stringify(value))
                    : JSON.stringify(value);
                queryParts.push(`${encodedKey}=${encodedValue}`);
            } else {
                const encodedValue = shouldEncode ? encodeURIComponent(String(value)) : String(value);
                queryParts.push(`${encodedKey}=${encodedValue}`);
            }
        }
    }

    const queryString = queryParts.join('&');
    return prefix ? `${prefix}${queryString}` : queryString;
}
